module.exports = __webpack_public_path__ + "assets/img/enterPrise.06b2b480.png";